import request from '@/router/axios';
const urlPrefix = '/wage'



//查询成本中心对比列表表头
export function  getCostCenterComparisonColumns(obj) {
  return request({
    url: urlPrefix + '/report/getCostCenterComparisonColumns',
    method: 'POST',
    data: obj
  })
}

//查询成本中心列表数据
export function  getCostCenterComparisonColumnList(obj) {
  return request({
    url: urlPrefix + '/report/getCostCenterComparisonColumnList',
    method: 'POST',
    data: obj
  })
}

//查询年度平均工资明细列表表头
export function  getAverageWageDetailColumnsList(obj) {
  return request({
    url: urlPrefix + '/report/getAverageWageDetailColumnsList',
    method: 'POST',
    data: obj
  })
}

//查询年度工资汇总列表表头
export function  getWageSummaryColumnsList(obj) {
  return request({
    url: urlPrefix + '/report/getWageSummaryColumnsList',
    method: 'POST',
    data: obj
  })
}

//查询年度平均工资汇总列表数据
export function  getSalaryWageSumList(obj) {
  return request({
    url: urlPrefix + '/report/getSalaryWageSumList',
    method: 'POST',
    data: obj
  })
}


//查询平均工资报表自定义所有项
export function  getAverageWageColumnsList(obj) {
  return request({
    url: urlPrefix + '/report/getAverageWageColumnsList',
    method: 'POST',
    data: obj
  })
}

/*//过滤平均工资汇总表
export function  getAverageWageCustomList(obj) {
  return request({
    url: urlPrefix + '/report/getAverageWageCustomList',
    method: 'POST',
    data: obj
  })
}*/

//过滤平均工资明细表
export function  getAverageWageDetailCustomList(obj) {
  return request({
    url: urlPrefix + '/report/getAverageWageDetailCustomList',
    method: 'POST',
    data: obj
  })
}

//查询成本中心汇总表自定义所有项
export function  getCostCenterSummaryColumnsList(obj) {
  return request({
    url: urlPrefix + '/report/getCostCenterSummaryColumnsList',
    method: 'POST',
    data: obj
  })
}
//查询工资对比表自定义所有项
export function  getWageComparisonColumnsList(obj) {
  return request({
    url: urlPrefix + '/report/getWageComparisonColumnsList',
    method: 'POST',
    data: obj
  })
}
//查询成本核算报表自定义所有项
export function  getCostAccountingColumnsList(obj) {
  return request({
    url: urlPrefix + '/report/getCostAccountingColumnsList',
    method: 'POST',
    data: obj
  })
}
//查询员工工资明细表自定义所有项
export function  getEmpWagesDetailColumnsList(obj) {
  return request({
    url: urlPrefix + '/report/getEmpWagesDetailColumnsList',
    method: 'POST',
    data: obj
  })
}
//新增平均工资报表自定义表头
export function  addAverageWageCustom(List) {
  return request({
    url: urlPrefix + '/report/addAverageWageCustom',
    method: 'POST',
    data: List
  })
}
//新增成本中心对比报表自定义表头
export function  addCostCenterComparison(List) {
  return request({
    url: urlPrefix + '/report/addCostCenterComparison',
    method: 'POST',
    data: List
  })
}
//新增工资对比自定义表头
export function  addWageComparison(List) {
  return request({
    url: urlPrefix + '/report/addWageComparison',
    method: 'POST',
    data: List
  })
}
//新增成本核算报表自定义表头
export function  addCostAccounting(List) {
  return request({
    url: urlPrefix + '/report/addCostAccounting',
    method: 'POST',
    data: List
  })
}
//新增员工工资明细自定义表头
export function  addAverageWageCustomDetail(List) {
  return request({
    url: urlPrefix + '/report/addAverageWageCustomDetail',
    method: 'POST',
    data: List
  })
}
//新增员工工资汇总自定义表头
export function  addWageSalarySummaryColumns(List) {
  return request({
    url: urlPrefix + '/report/addWageSalarySummaryColumns',
    method: 'POST',
    data: List
  })
}
//新增成本中心汇总报表自定义表头
export function  addCostCenterSummary(List) {
  return request({
    url: urlPrefix + '/report/addCostCenterSummary',
    method: 'POST',
    data: List
  })
}
//删除报表自定义表头
export function  deleteReportItemById(id) {
  return request({
    url: urlPrefix + '/report/addAverageWageCustom'+id,
    method: 'delete',
    data: id
  })
}



//查询平均工资报表表头及数据
export function  getAverageWageCustomColumnList(obj) {
  return request({
    url: urlPrefix + '/report/getAverageWageCustomColumnList',
    method: 'POST',
    data: obj
  })
}
//查询成本中心汇总表表头及数据
export function  getCostCenterSummaryColumnList(obj) {
  return request({
    url: urlPrefix + '/report/getCostCenterSummaryColumnList',
    method: 'POST',
    data: obj
  })
}
//查询工资对比表表头及数据
export function  getWageComparisonColumnList(obj) {
  return request({
    url: urlPrefix + '/report/getWageComparisonColumnList',
    method: 'POST',
    data: obj
  })
}
//查询成本核算报表表头及数据
export function  getCostAccountingColumnList(obj) {
  return request({
    url: urlPrefix + '/report/getCostAccountingColumnList',
    method: 'POST',
    data: obj
  })
}
//查询员工工资明细表表头及数据
export function  getEmpWagesDetailColumnList(obj) {
  return request({
    url: urlPrefix + '/report/getEmpWagesDetailColumnList',
    method: 'POST',
    data: obj
  })
}

//查询税率汇总报表所有报表不用自定义表头直接查询数据
export function  getTaxRateSummaryList(obj) {
  return request({
    url: urlPrefix + '/report/getTaxRateSummaryList',
    method: 'POST',
    data: obj
  })
}

//查询年度平均工资列表表头
export function  getWageAverageColumnsList(obj) {
  return request({
    url: urlPrefix + '/report/getWageAverageColumnsList',
    method: 'POST',
    data: obj
  })
}
//保存年度平均工资表头
export function  addWageSalaryAverageColumns(List) {
  return request({
    url: urlPrefix + '/report/addWageSalaryAverageColumns',
    method: 'POST',
    data: List
  })
}

//查询年度平均工资列表数据
export function  getSalaryWageAverageList(obj) {
  return request({
    url: urlPrefix + '/report/getSalaryWageAverageList',
    method: 'POST',
    data: obj
  })
}
